import { BankIcon, CartIcon, FileIcon, InvoiceIcon } from "@codat/orchard-ui";
import { DataConnection } from "api/public";
import classNames from "classnames";
import React from "react";

import styles from "./ConnectionsTable.module.scss";

interface ConnectionIconProps {
  sourceType: DataConnection["sourceType"];
}

export const ConnectionIcon = ({ sourceType }: ConnectionIconProps) => {
  switch (sourceType) {
    case "Accounting":
      return (
        <div
          className={classNames(styles.connectionIcon, styles.accountingIcon)}
        >
          <InvoiceIcon />
        </div>
      );
    case "Commerce":
      return (
        <div className={classNames(styles.connectionIcon, styles.commerceIcon)}>
          <CartIcon />
        </div>
      );
    case "Banking":
      return (
        <div className={classNames(styles.connectionIcon, styles.bankingIcon)}>
          <BankIcon />
        </div>
      );
    case "Other":
      return (
        <div className={classNames(styles.connectionIcon, styles.fileIcon)}>
          <FileIcon />
        </div>
      );

    default:
      return null;
  }
};
